var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from "vue-property-decorator";
import { Dependencies } from '~/core/decorator';
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service.ts';
import { State, namespace } from "vuex-class";
import { MENU_CHANNEL } from "~/config/enum.config";
var CollectionExecutionModule = namespace('collection-execution');
var HoldCourtStep = /** @class */ (function (_super) {
    __extends(HoldCourtStep, _super);
    function HoldCourtStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            legalStatus: "COME_UP",
            id: "",
            comeUpTime: "",
            comeUpPlace: "",
            comeUpName: "",
            judgeName: "",
            judgePhone: "",
            courtTrialResults: "",
            legalInstrumentDate: "",
            effectiveDate: "",
            comeUpRemark: "",
        };
        _this.rules = {
            comeUpTime: [{ required: true, message: "请输入开庭时间" }],
            comeUpPlace: [{ required: true, message: "请输入开庭地点" }],
            comeUpName: [{ required: true, message: "请输入开庭人" }],
            judgePhone: { validator: _this.$validator.phoneNumber, trigger: 'blur' }
        };
        _this.submitLoading = false;
        return _this;
    }
    HoldCourtStep.prototype.nextStepEmit = function () { };
    HoldCourtStep.prototype.previousStepEmit = function () { };
    HoldCourtStep.prototype.finishCaseEmit = function () { };
    HoldCourtStep.prototype.emitSuccess = function () {
        if (this.id) {
            this.showLegalInfoById(this.id);
        }
        else {
            // this.showLegalInfo();
        }
    };
    Object.defineProperty(HoldCourtStep.prototype, "isShow", {
        get: function () {
            var _this = this;
            var arr = [MENU_CHANNEL.Legal_personal, MENU_CHANNEL.Legal_team, MENU_CHANNEL.Assist_legal];
            if (arr.find(function (v) { return _this.menuChannel === v; })) {
                // 添加催记显示保存按钮 或编辑催记 与该登录用户一致显示
                if (!this.operatorId || this.operatorId === this.userData.id)
                    return true;
                else
                    return false;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    HoldCourtStep.prototype.showLegalInfoById = function (id) {
        var _this = this;
        if (id) {
            this.caseOperatorPageService
                .queryCaseLegalRecordById(this.id)
                .subscribe(function (data) {
                if (data) {
                    _this.formData.id = data.id;
                    _this.formData.comeUpTime = data.comeUpTime;
                    _this.formData.comeUpPlace = data.comeUpPlace;
                    if (data.isComeUp === "YES") {
                        _this.formData.comeUpName = data.comeUpName;
                    }
                    _this.formData.judgeName = data.judgeName;
                    _this.formData.judgePhone = data.judgePhone;
                    _this.formData.courtTrialResults = data.courtTrialResults;
                    _this.formData.legalInstrumentDate = data.legalInstrumentDate;
                    _this.formData.effectiveDate = data.effectiveDate;
                    _this.formData.comeUpRemark = data.comeUpRemark;
                }
            }, function (err) {
            });
        }
    };
    HoldCourtStep.prototype.mounted = function () {
        if (this.id) {
            this.showLegalInfoById(this.id);
        }
        else {
            this.formData.comeUpName = this.userData.realName;
            // this.showLegalInfo();
        }
    };
    HoldCourtStep.prototype.showLegalInfo = function () {
        var _this = this;
        //查询上一条催记是否结案，回显数据
        this.caseOperatorPageService
            .queryUnClossCaseLegalRecord(this.caseId)
            .subscribe(function (data) {
            if (data) {
                _this.formData.id = data.id;
                _this.formData.comeUpTime = data.comeUpTime;
                _this.formData.comeUpPlace = data.comeUpPlace;
                if (data.isComeUp === "YES") {
                    _this.formData.comeUpName = data.comeUpName;
                }
                _this.formData.judgeName = data.judgeName;
                _this.formData.judgePhone = data.judgePhone;
                _this.formData.courtTrialResults = data.courtTrialResults;
                _this.formData.legalInstrumentDate = data.legalInstrumentDate;
                _this.formData.effectiveDate = data.effectiveDate;
                _this.formData.comeUpRemark = data.comeUpRemark;
            }
        }, function (err) {
        });
    };
    HoldCourtStep.prototype.submit = function () {
        var _this = this;
        var form = this.$refs["hold-court-step-form"];
        form.validate(function (valid) {
            if (!valid)
                return false;
            if (_this.menuChannel === MENU_CHANNEL.Assist_legal) {
                _this.formData.assistId = _this.otherData.assistId;
            }
            _this.formData.caseId = _this.caseId;
            if (_this.formData.comeUpTime)
                _this.formData.comeUpTime = _this.$filter.dateTimeFormat(_this.formData.comeUpTime);
            if (_this.formData.effectiveDate)
                _this.formData.effectiveDate = _this.$filter.dateFormat(_this.formData.effectiveDate);
            if (_this.formData.legalInstrumentDate)
                _this.formData.legalInstrumentDate = _this.$filter.dateFormat(_this.formData.legalInstrumentDate);
            _this.caseOperatorPageService
                .addCaseLegalRecord(_this.formData)
                .subscribe(function (data) {
                form.resetFields();
                _this.formData.id = "";
                _this.emitSuccess();
                _this.$message.success('法催催记开庭已添加成功，如需修改请在法务详情中进行修改');
            }, function (err) {
                _this.submitLoading = false;
            });
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], HoldCourtStep.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], HoldCourtStep.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], HoldCourtStep.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], HoldCourtStep.prototype, "otherData", void 0);
    __decorate([
        Prop({ type: String, required: false })
    ], HoldCourtStep.prototype, "id", void 0);
    __decorate([
        Prop({ type: String })
    ], HoldCourtStep.prototype, "operatorId", void 0);
    __decorate([
        State
    ], HoldCourtStep.prototype, "userData", void 0);
    __decorate([
        Emit('nextStep')
    ], HoldCourtStep.prototype, "nextStepEmit", null);
    __decorate([
        Emit('previousStep')
    ], HoldCourtStep.prototype, "previousStepEmit", null);
    __decorate([
        Emit('finishCase')
    ], HoldCourtStep.prototype, "finishCaseEmit", null);
    __decorate([
        Emit('emitSuccess')
    ], HoldCourtStep.prototype, "emitSuccess", null);
    HoldCourtStep = __decorate([
        Component({
            components: {}
        })
    ], HoldCourtStep);
    return HoldCourtStep;
}(Vue));
export default HoldCourtStep;
